

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _util = require('xo-return-to-merchant/dist/util');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _redirectSanitizer = require('../../../js/lib/redirectSanitizer');

require('./styles');

var _util2 = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var INVALID_ADDRESS_KEY_MAPPING = {
    TITLE: 'errorInfo',
    CONTENT: 'errorDetail'
};

exports['default'] = _squid.$Component.extend('$xoInvalidAddressComponent', {
    tag: 'xo-invalid-address-error',
    template: _template2['default'],

    resolve: {
        models: function models() {}
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _angular.$rootScope.isShoppingCart = true;

            var xclickParams = _squid.$meta.xclickParams;

            this.mappedParameters = (0, _util2.getInvalidAddressRequiredParams)(xclickParams);

            this.requiredDetailsForAddressOverride = this.mappedParameters && this.mappedParameters.requiredDetailsForAddressOverride;

            var rawCancelReturn = this.requiredDetailsForAddressOverride && this.requiredDetailsForAddressOverride.urls && this.requiredDetailsForAddressOverride.urls.cancel_return;
            this.redirectLink = (0, _redirectSanitizer.sanitizeRedirectUrl)(rawCancelReturn) || document.referrer;

            var merchantDetails = (0, _util2.getMerchantDetails)(this.requiredDetailsForAddressOverride);
            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);
            this.merchant = merchantDetails;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            this.redirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = this.redirectLink;
                _util.$ReturnToMerchant.goTo(redirectUrl);
            };

            $('.paypalHeaderWrapper').hide();
            $('#defaultCancelLink').hide();
            $('.footerWrapper').addClass('genericError');

            var titleKey = INVALID_ADDRESS_KEY_MAPPING.TITLE;

            if (titleKey) {
                this.titleKey = 'shippingAddress.' + titleKey;
            }

            var contentKey = INVALID_ADDRESS_KEY_MAPPING.CONTENT;

            this.contentKey = 'shippingAddress.' + contentKey;

            this.$on('$destroy', function (event) {
                $('.paypalHeaderWrapper').show();
                $('#defaultCancelLink').show();
                $('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            this.getTitle = function () {
                var key = _this.titleKey;

                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            this.getContent = function () {

                var key = _this.contentKey;

                return (0, _squid.$renderContent)(key);
            };

            // Returns the redirect to merchant button label, based on presence of brand/merchant name
            this.getRedirectLabel = function () {
                var merchantName = _this.merchant.brand_name;

                if (merchantName) {
                    return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
                }

                return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
            };
        },
        populate: function populate() {}
    }
});


_squid.$Component;

_squid.$meta;

_squid.$renderContent;

_angular.$rootScope;

_util.$ReturnToMerchant;

_redirectSanitizer.sanitizeRedirectUrl;

_util2.getInvalidAddressRequiredParams;

_util2.getMerchantDetails;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-invalid-address-error/directive.js
// module id = ./pages/xo-error/xo-invalid-address-error/directive.js
// module chunks = 0